import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import NavBreadcrum from "components/NavBreadcrum";
//
import axiApi from "ApiCaller";
import navs from "./navs";
import ContainersListFilters from "./containers-list/ContainersListFilters";
import ContainersListTable from "./containers-list/ContainersListTable";
import {SwalAlertClass} from "core/swalClass";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import OrderingModel from "components/ordering/OrderingModel";


const ReportContainerPickedUp = () => {
    const {t: _Tr} = useTranslation("routes")
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"})
    const title = "Contenedores por porcentaje"
    const bread = [
        {name: _Tr("labels.reports"), url: "/reports/", current: false},
        {name: title, current: true}
    ]
    const items = useRef([]);
    const [itemsShown, setItemsShown] = useState([]);
    const itemsRef = useRef([]);
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const [isLoading, setIsLoading] = useState(false);
    const [params, setParams] = useState({
        groups: [],
        islands: [],
        routes: [],
        zones: [],
    });


    const orderingRef = useRef(new OrderingModel());

    useEffect(() => {
        document.title = title
        orderingRef.current.applyOrder = () => {
            applyFilters()
        }
        axiApi.get("/api/reports/containers/filters/").then(resp => {
            let params_ = {...params}
            params_.groups = [...resp.data.groups];
            params_.islands = [...resp.data.islands];
            params_.routes = [...resp.data.routes];
            params_.zones = [...resp.data.zones];
            setParams(params_);
        })
        pagerModelRef.current.active = false;
        pagerModelRef.current.handleCallApi = () => {
            applyFilters()
        }
    }, []);

    const applyFilters = () => {
        setIsLoading(true);
        axiApi.post("/api/reports/containers/filter/list/",
            filters.current.chosen,
            {params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()}}
        ).then(resp => {
            items.current = [...resp.data.items];
            itemsRef.current = [...resp.data.items];
            setItemsShown([...resp.data.items]);
            if (resp.data.pager) {
                pagerModelRef.current.active = true;
                pagerModelRef.current.paging.update(resp.data.pager);
            }
        }).finally(() => {
            setIsLoading(false);
        })
    }

    const downloadFilters = () => {
        if (items.current.length === 0) {
            Alert.warning("No hay registros para descargar");
            return false;
        }
        axiApi.post("/api/reports/containers/filter/list/download/", filters.current.chosen, {
            responseType: 'blob',
        }).then(resp => {
            const contentDisposition = resp.headers['content-disposition'];
            const contentType = resp.headers['content-type'];
            let filename = 'downloaded-file';
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                if (filenameMatch.length === 2) {
                    filename = filenameMatch[1];
                }
            }
            const linkTemp = document.createElement('a');
            linkTemp.href = window.URL.createObjectURL(
                new Blob([resp.data], {type: contentType})
            );
            linkTemp.setAttribute('download', filename);
            document.body.appendChild(linkTemp);
            linkTemp.click();
            document.body.removeChild(linkTemp);
        })
    }

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread}/>
            <div className="row">
                <div className="col-12">
                    <h5 className="mt-2 mb-3">{title}</h5>
                    <ContainersListFilters
                        filters={filters}
                        params={params}
                        applyFilters={applyFilters}
                        downloadFilters={downloadFilters}
                        setItemsShown={setItemsShown}
                    />

                </div>
                <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="72px"/>
                <div className="col-12">
                    <LoaderSpinner isLoading={isLoading}>
                        <ContainersListTable
                            itemsShown={itemsShown}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
            </div>
        </>
    )
}
export default ReportContainerPickedUp;